import { createSelector, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../context/store'
import appList from '../../../data/apps.json';
import { IPageMetaData } from './useAppsWithImages';

export interface IAppsState {
    list: IPageMetaData[]
}

export const AppsInitialState: IAppsState = {
    list: appList
}

export const providersSlice = createSlice({
    name: 'apps',
    initialState: AppsInitialState,
    reducers: {
    },
});

// Base Selectors
export const selectString = (_: RootState, s: string) => s;
export const selectAppsBase = (state: RootState) => state.apps.list;

// Reselectors
export const selectApps = createSelector(selectAppsBase, (items) => items);
export const selectAppByIdentifier = createSelector(
    selectAppsBase,
    selectString,
    (items: IPageMetaData[], identifier: string) => {
        return items.find(i => i.identifier === identifier)
    }
)
export const selectVisibleApps = createSelector(
    selectAppsBase,
    (items: IPageMetaData[]) => {
        if (process.env.NODE_ENV === 'production')
            return items.filter(i => i.isVisible === true)
        else
            return items
    }
)

export const { } = providersSlice.actions;
export default providersSlice.reducer;
